import React from 'react';
import styled from '@emotion/styled';

const Container = styled.main`
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 2rem;
  color: var(--primary);
  margin-bottom: 2rem;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

const Disclaimer = styled.div`
  background: #fff3cd;
  border: 2px solid #ffeeba;
  padding: 1rem;
  margin: 2rem 0;
  border-radius: 8px;
  font-weight: bold;
  color: #856404;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const HerbCard = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 1.5rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const HerbTitle = styled.h3`
  font-size: 1.3rem;
  color: var(--secondary);
  margin-bottom: 0.5rem;
`;

const HerbDescription = styled.p`
  line-height: 1.6;
  color: #2d3748;
`;

const StressReliefHerbs: React.FC = () => {
  return (
    <Container>
      <Title>Natural Herbs for Stress Relief</Title>

      <Disclaimer>
        ⚠️ IMPORTANT: Please consult your healthcare provider before taking any supplements and/or herbal remedies. 
        Some herbs can have serious side effects, interact with medications, or cause severe allergic reactions. 
        Natural does not always mean safe.
      </Disclaimer>

      <Section>
        <HerbCard>
          <HerbTitle>Ashwagandha (Withania somnifera)</HerbTitle>
          <HerbDescription>
            An ancient medicinal herb used in Ayurvedic medicine. Known for its adaptogenic properties,
            helping the body manage stress. Research suggests it may help reduce cortisol levels and anxiety.
          </HerbDescription>
        </HerbCard>

        <HerbCard>
          <HerbTitle>Lavender (Lavandula angustifolia)</HerbTitle>
          <HerbDescription>
            Well-known for its calming properties. Can be used as tea, essential oil, or supplement.
            Studies show it may help reduce anxiety and improve sleep quality.
          </HerbDescription>
        </HerbCard>

        <HerbCard>
          <HerbTitle>Chamomile (Matricaria chamomilla)</HerbTitle>
          <HerbDescription>
            A gentle herb commonly consumed as tea. Contains compounds that may promote relaxation
            and help with sleep. Long history of use for stress and anxiety relief.
          </HerbDescription>
        </HerbCard>

        <HerbCard>
          <HerbTitle>Saffron (Crocus sativus)</HerbTitle>
          <HerbDescription>
            A precious spice with potential mood-boosting properties. Research indicates it may help
            with anxiety and stress-related symptoms. Known for its antioxidant properties.
          </HerbDescription>
        </HerbCard>

        <HerbCard>
          <HerbTitle>Lemon Balm (Melissa officinalis)</HerbTitle>
          <HerbDescription>
            A member of the mint family that has been used for centuries to reduce stress and anxiety.
            May help improve mood and cognitive function.
          </HerbDescription>
        </HerbCard>

        <HerbCard>
          <HerbTitle>Passionflower (Passiflora incarnata)</HerbTitle>
          <HerbDescription>
            Traditional remedy for anxiety and insomnia. Studies suggest it may help reduce anxiety
            symptoms and improve sleep quality.
          </HerbDescription>
        </HerbCard>

        <HerbCard>
          <HerbTitle>Rhodiola (Rhodiola rosea)</HerbTitle>
          <HerbDescription>
            An adaptogenic herb that may help the body adapt to stress. Some studies suggest it
            may help combat fatigue and improve stress resistance.
          </HerbDescription>
        </HerbCard>
      </Section>

      <Disclaimer>
        ⚠️ REMINDER: Always consult with a healthcare professional before starting any herbal supplement regimen.
        Herbal remedies can interact with medications and may not be safe for everyone.
      </Disclaimer>

      <Disclaimer>
        ⚠️ FINAL WARNING: Natural supplements and herbs can be powerful medicines with real risks.
        Never self-diagnose or self-treat serious medical conditions. Seek professional medical advice.
      </Disclaimer>
    </Container>
  );
};

export default StressReliefHerbs; 